import React from 'react';

import { WorkspaceLayout } from '../../../shared/components/Layout';
import Form from './Form';

const Settings = () => (
  <WorkspaceLayout>
    <span className="font-medium text-sm">
      Specify details related to your review requests.
    </span>

    <Form />
  </WorkspaceLayout>
);

export default Settings;
